import { render, staticRenderFns } from "./CancelSignup.vue?vue&type=template&id=bc4cb02a"
import script from "./CancelSignup.vue?vue&type=script&lang=js"
export * from "./CancelSignup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports